import CobWeb from "~/components/CobWeb";
import CobWebDepartment from "~/components/CobWeb/CobWebDepartment";
import SystemRoles from "~/components/Icons/Menu/SystemRoles";
import PageNotFound from "~/pages/404";
import Accounting from "~/pages/Accounting";
import AccountingDealer from "~/pages/Accounting/AccountingDealer";
import AccountingPeriod from "~/pages/Accounting/AccountingPeriod";
import Announcement from "~/pages/Announcement";
import AnnouncementEdit from "~/pages/Announcement/AnnouncementEdit";
import AnnouncementViewing from "~/pages/Announcement/AnnouncementViewing";
import BaseStaff from "~/pages/BaseStaff";
import EmployeeProfileEditor from "~/pages/BaseStaff/EmployeeProfileEditor";
import EmployeeProfileViewing from "~/pages/BaseStaff/EmployeeProfileViewing";
import CameraZonesView from "~/pages/CameraZonesView";
import CatalogApplications from "~/pages/CatalogApplications";
import CatalogInfo from "~/pages/CatalogApplications/CatalogInfa";
import Catalogs from "~/pages/Catalogs";
import Checklists from "~/pages/Checklists";
import Checklist from "~/pages/Checklists/parts/CheckList";
import DepartmentCheckList from "~/pages/Checklists/parts/DepartmentCheckList";
import DealerPassport from "~/pages/DealerPassport";
import DealersPage from "~/pages/Dealers";
import DealerPeriod from "~/pages/Dealers/DealerPeriod";
import DealersArchive from "~/pages/Dealers/DealersArchive";
import DealersInheritance from "~/pages/Dealers/DealersInheritance";
import AdditionalTariffs from "~/pages/Directory/AdditionalTariffs";
import BaseTariffs from "~/pages/Directory/BaseTariffs";
import PersonalTariffs from "~/pages/Directory/PersonalTariffs";
import Documents from "~/pages/Documents";
import DocumentView from "~/pages/DocumentViewing";
import AddressSelectionGuide from "~/pages/Editor/AddressSelectionGuide";
import ContestTerritories from "~/pages/Editor/ContestTerritories";
import ContractTemplates from "~/pages/Editor/ContractTemplates";
import DnmRoleMappings from "~/pages/Editor/DnmRoleMappings";
import EditorPage from "~/pages/Editor/Editor";
import EditorCameraZones from "~/pages/Editor/EditorCameraZones";
import EditorCatalogEducationalPrograms from "~/pages/Editor/EditorCatalogEducationalPrograms";
import EditorCourses from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorCourses";
import EditorGroups from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorGroups";
import EditorLevels from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorLevels";
import EditorPositionsAndTrainingPrograms from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms";
import ProgramsManagement from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement";
import EditorDealerMetric from "~/pages/Editor/EditorDealerMetric";
import EditorDirectories from "~/pages/Editor/EditorDirectories";
import EditorCombinationRules from "~/pages/Editor/EditorDirectories/EditorCombinationRules";
import EditorDirections from "~/pages/Editor/EditorDirectories/EditorDirections";
import EditorPositionsDirectory from "~/pages/Editor/EditorDirectories/EditorPositionsDirectory";
import EditorDocumentSection from "~/pages/Editor/EditorDocumentSection";
import EditorGRIndicators from "~/pages/Editor/EditorGRIndicators";
import EditorInformationSystems from "~/pages/Editor/EditorInformationSystems";
import EditorInformationSystem from "~/pages/Editor/EditorInformationSystems/EditorInformationSystem";
import EditorPersonalData from "~/pages/Editor/EditorInformationSystems/EditorPersonalData";
import EditorPhotoGallery from "~/pages/Editor/EditorPhotoGallery";
import EditorQIndicators from "~/pages/Editor/EditorQIndicators";
import EditorReports from "~/pages/Editor/EditorReports";
import EditorServiceAuthorization from "~/pages/Editor/EditorServiceAuthorization";
import EditorStaffIndicators from "~/pages/Editor/EditorStaff";
import EditorSubdivision from "~/pages/Editor/EditorSubdivision";
import EditorTrustedPersons from "~/pages/Editor/EditorTrustedPersons";
import EditorVersions from "~/pages/Editor/EditorVersions";
import ViolationType from "~/pages/Editor/EditorViolation";
import IvideonPlans from "~/pages/Editor/IvideonPlans";
import Employee from "~/pages/Employee";
import GRPage from "~/pages/GR";
import IndicatorReports from "~/pages/IndicatorReports";
import ViewReport from "~/pages/IndicatorReports/ViewReport";
import IndicatorsPage from "~/pages/Indicators";
import Ivideon from "~/pages/Ivideon";
import CameraList from "~/pages/Ivideon/CameraList";
import IvideonDealerRegistry from "~/pages/IvideonDealerRegistry";
import LicenseManagement from "~/pages/LicenseManagement";
import LicenseOrganization from "~/pages/LicenseOrganization";
import LicensePositionGroup from "~/pages/LicensePositionGroup";
import LogsPage from "~/pages/Logs";
import EmailLogs from "~/pages/Logs/EmailLogs";
import MainPage from "~/pages/Main";
import Partners from "~/pages/Partners";
import PhotoGallery from "~/pages/PhotoGallery";
import PKD from "~/pages/PKD";
import PKDFiles from "~/pages/PKD/PKDFiles";
import PlanReport from "~/pages/PlanReport";
import QPage from "~/pages/Q";
import RegistryOfRole from "~/pages/RegistryOfRole";
import RoleModel from "~/pages/RegistryOfRole/RoleModel";
import RegMen from "~/pages/RegMen";
import SRR from "~/pages/SRR/";
import GIBDD from "~/pages/SRR/GIBDD";
import StaffPage from "~/pages/Staff";
import StaffEmployeePersonal from "~/pages/StaffEmployeePersonal";
import TrainingManagement from "~/pages/TrainingManagement";
import UploadsPage from "~/pages/Uploads";
import UsersPage from "~/pages/Users";
import ViolationRecording from "~/pages/ViolationRecording";
import Violations from "~/pages/Violations";
import ViolationDescription from "~/pages/Violations/ViolationDescription";
import ZDPage from "~/pages/ZD";
import ZDPageHOC from "~/pages/ZD/HOC";
import ZDPageUsuo from "~/pages/ZD/MainZD";
import { Appeal } from "~/pages/Appeal";
import { EducationalProgramsManagement } from "~/pages/Editor/EditorCatalogEducationalPrograms/EducationalProgramsManagement";
import { EDITOR_PAGE_PERMISSIONS } from "~/pages/Editor/options";
import { StaffTraining } from "~/pages/StaffTraining";
import { StaffTrainingDetails } from "~/pages/StaffTrainingDetails";
import { IRoute } from "~/types/Routes";

import BonusQReport from "./pages/BonusQReport";
import DNM from "./pages/DNM";
import RequisitesPage from "./pages/Editor/RequisitesPage";
import HistoryCameras from "./pages/HistoryCameras";
import HistoryRegisterOfDocuments from "./pages/HistoryRegisterOfDocuments";
import IvideonDealerSummary2 from "./pages/IvideonDealerSummary2";
import ListOfDocuments from "./pages/ListOfDocuments";
import IntegrationsLogs from "./pages/Logs/IntegrationsLogs";
import IvideonLogs from "./pages/Logs/IvideonLogs";
import RegisterOfDocuments from "./pages/RegisterOfDocuments";
import StaffBonus from "./pages/StaffBonus";

export const ROUTES: IRoute[] = [
  {
    name: "PASSPORT",
    pageComponent: MainPage,
    path: "/",
    permissions: ["passport.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "ZD_USUO",
    pageComponent: ZDPageHOC,
    path: "/zd/main/",
    icon: SystemRoles,
    permissions: [
      "zd.common.get",
      "zd.personalCheck",
      "zd.tradePremisesCheck",
      "zd.toolsCheck",
      "zd.warehousesCheck",
      "zd.placePostCheck",
      "zd.placesCheck",
      "zd.servicesCheck",
      "zd.requiredToolsCheck",
      "zd.notesCheck",
      "zd.toolsInsuranceCheck",
      "zd.toolsMetrologicalCheck",
      "zd.servicesEdit",
      "zd.placesEdit",
      "zd.placePostEdit",
      "zd.warehousesEdit",
      "zd.toolsEdit",
      "zd.requiredToolsEdit",
      "zd.personalEdit",
      "zd.toolsInsuranceEdit",
      "zd.toolsMetrologicalEdit",
      "zd.notesEdit",
      "zd.tradePremisesEdit",
    ],
    exact: true,
  },
  {
    name: "ZD",
    pageComponent: ZDPageUsuo,
    path: "/zd/",
    icon: SystemRoles,
    permissions: ["zd.common.get"],
    exact: true,
    nav: {
      group: "accounting",
      groupTitle: "headerMenu.accounting",
      title: "headerMenu.accounting_sub_ZD",
      order: 2,
    },
  },
  {
    name: "ACCOUNTING",
    pageComponent: Accounting,
    path: "/accounting/",
    icon: SystemRoles,
    permissions: ["accounting.getPeriod"],
    exact: true,
    nav: {
      group: "accounting",
      title: "headerMenu.accounting_sub_Buhgalteriya",
      order: 1,
    },
  },
  {
    name: "ACCOUNTING_DEALER",
    pageComponent: AccountingDealer,
    path: "/accounting/:period",
    icon: SystemRoles,
    exact: true,
    permissions: ["accounting.getDealerReports"],
  },
  {
    name: "ACCOUNTING_PERIOD",
    pageComponent: AccountingPeriod,
    path: "/accounting/:period/:id",
    icon: SystemRoles,
    permissions: ["accounting.getDealerReport"],
    exact: true,
  },
  {
    name: "GR",
    pageComponent: GRPage,
    path: "/gr/",
    icon: SystemRoles,
    permissions: ["globalRatings.ratingData.get"],
    exact: true,
    nav: {
      group: "analytics",
      groupTitle: "headerMenu.analytics",
      title: "headerMenu.analytics_sub_GR",
      order: 2,
    },
  },
  {
    name: "Q",
    pageComponent: QPage,
    path: "/q/",
    icon: SystemRoles,
    permissions: ["quartilesRatings.ratingData.get"],
    exact: true,
    nav: {
      group: "analytics",
      title: "headerMenu.analytics_sub_Q",
      order: 1,
    },
  },
  {
    name: "STAFF",
    pageComponent: StaffPage,
    path: "/staff/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.get"],
    exact: true,
    nav: {
      group: "staff",
      groupTitle: "headerMenu.staff",
      title: "headerMenu.staff_sub_Staff",
      order: 2,
    },
  },
  {
    name: "DNM",
    pageComponent: DNM,
    path: "/dnm/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.employee.compare"],
    exact: true,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_DNM",
      order: 7,
    },
  },
  {
    name: "EMPLOYEE",
    pageComponent: Employee,
    path: "/staff/employee",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.get"],
    exact: true,
  },
  {
    name: "StaffBonus",
    pageComponent: StaffBonus,
    path: "/staff/bonus",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.bonus.report.get"],
    exact: false,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_StaffBonus",
      order: 4,
    },
  },
  {
    name: "StaffBonus",
    pageComponent: Appeal,
    path: "/staff/appeals",
    icon: SystemRoles,
    permissions: ["employeeAccounting.appeal.getList"],
    exact: false,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_StaffAppeals",
      order: 6,
    },
  },
  {
    name: "StaffTrainingFact",
    pageComponent: StaffTrainingDetails,
    path: "/staff/training/fact",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.get"],
    exact: false,
  },
  {
    name: "StaffTrainingFact",
    pageComponent: StaffTrainingDetails,
    path: "/staff/training/completed",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.get"],
    exact: false,
  },
  {
    name: "StaffTrainingFact",
    pageComponent: StaffTrainingDetails,
    path: "/staff/training/required",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.get"],
    exact: false,
  },
  {
    name: "StaffTraining",
    pageComponent: StaffTraining,
    path: "/staff/training",
    permissions: ["employeeAccounting.statistics.get"],
    icon: SystemRoles,
    exact: false,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_StaffTraining",
      order: 3,
    },
  },
  {
    name: "StaffBonus",
    pageComponent: BonusQReport,
    path: "/staff/bonus-q-report",
    icon: SystemRoles,
    permissions: ["employeeAccounting.statistics.quarter"],
    exact: false,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_StaffBonusQReport",
      order: 5,
    },
  },
  {
    name: "DEALERS",
    pageComponent: DealersPage,
    path: "/dealers/",
    icon: SystemRoles,
    permissions: ["dealers.getDealers"],
    exact: true,
    nav: {
      group: "dealers",
      groupTitle: "headerMenu.dealers",
      title: "headerMenu.dealers_sub_Dealers",
      order: 1,
    },
  },

  {
    name: "DEALERS_PERIOD",
    pageComponent: DealerPeriod,
    path: "/dealers/period/",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "DEALERS_INHERITANCE",
    pageComponent: DealersInheritance,
    path: "/dealers/inheritance/",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "DEALERS_ARCHIVE",
    pageComponent: DealersArchive,
    path: "/dealers/period/:period/",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "DEALERS_ARCHIVE_PASSPORT",
    pageComponent: DealerPassport,
    path: "/dealers/period/:period/:id",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "LIST_OF_DOCUMENTS",
    pageComponent: ListOfDocuments,
    path: "/dealers/list-of-documents/",
    icon: SystemRoles,
    exact: true,
    permissions: ["contracts.dealers"],
    nav: {
      group: "dealers",
      title: "headerMenu.dealers_sub_DealersDocs",
      order: 3,
    },
  },
  {
    name: "DEALER",
    pageComponent: DealerPassport,
    path: "/dealers/:id",
    icon: SystemRoles,
    permissions: [
      "dealer.getBase",
      "dealer.getAddress",
      "dealer.getOwners",
      "dealer.getGuide",
      "dealer.getEmployee",
      "dealer.getDocs",
      "dealer.getEpd",
    ],
    exact: true,
  },
  {
    name: "ANNOUNCEMENT",
    pageComponent: Announcement,
    path: "/announcement/",
    icon: SystemRoles,
    permissions: ["announcements.get"],
    exact: true,
    nav: {
      group: "information",
      title: "headerMenu.information_sub_Announcements",
      order: 2,
    },
  },
  {
    name: "IVIDEON_CAMERAS",
    pageComponent: CameraList,
    path: "/ivideon/dealers/:currentDealerId/:cameraId/camera-list/",
    icon: SystemRoles,
    permissions: [
      "ivideonGroups.getGroups.sale",
      "ivideonGroups.getGroups.service",
    ],
    exact: true,
  },
  {
    name: "HISTORY_CAMERAS",
    pageComponent: HistoryCameras,
    path: "/ivideon/cameras/history/:dealerId",
    icon: SystemRoles,
    permissions: [
      "ivideonGroups.getGroups.sale",
      "ivideonGroups.getGroups.service",
    ],
    exact: true,
  },
  {
    name: "HISTORY_REGISTER_OF_DOCUMENTS",
    pageComponent: HistoryRegisterOfDocuments,
    path: "/ivideon/register-of-documents/history",
    icon: SystemRoles,
    permissions: ["ivideon.getDealerDocs"],
    exact: true,
  },
  {
    name: "REGISTER_OF_DOCUMENTS",
    pageComponent: RegisterOfDocuments,
    path: "/ivideon/register-of-documents",
    icon: SystemRoles,
    permissions: ["ivideon.getDealerDocs"],
    exact: true,
  },
  {
    name: "IVIDEON_DEALER_SUMMARY",
    pageComponent: IvideonDealerSummary2,
    path: "/ivideon/summary",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "IVIDEON_DEALER_REGISTRY",
    pageComponent: IvideonDealerRegistry,
    path: "/ivideon/dealers",
    icon: SystemRoles,
    permissions: ["ivideon.getDealers"],
    exact: true,
    nav: {
      group: "dealers",
      title: "headerMenu.dealers_sub_Cameras",
      order: 5,
    },
  },
  {
    name: "IVIDEON_DEALER_CAMERAS_REGISTRY",
    pageComponent: Ivideon,
    path: "/ivideon/dealers/:id",
    icon: SystemRoles,
    permissions: [
      "ivideonGroups.getGroups.sale",
      "ivideonGroups.getGroups.service",
    ],
    exact: true,
  },
  {
    name: "CAMERA_ZONES_VIEW",
    pageComponent: CameraZonesView,
    path: "/camera-view/",
    icon: SystemRoles,
    permissions: [
      "ivideonGroups.getGroups.sale",
      "ivideonGroups.getGroups.service",
    ],
    exact: true,
  },
  {
    name: "CAMERA_VIEW",
    pageComponent: CameraZonesView,
    path: "/camera-view/:id",
    icon: SystemRoles,
    permissions: [
      "ivideonGroups.getGroups.sale",
      "ivideonGroups.getGroups.service",
    ],
    exact: true,
  },
  {
    name: "PHOTO_GALLERY",
    pageComponent: PhotoGallery,
    path: "/photo-gallery/",
    icon: SystemRoles,
    permissions: ["dealer.getDealerPhotos"],
    exact: true,
    nav: {
      group: "dealers",
      title: "headerMenu.dealers_sub_PhotoGallery",
      order: 6,
    },
  },
  {
    name: "DOCUMENTS",
    pageComponent: Catalogs,
    path: "/documents/",
    icon: SystemRoles,
    permissions: ["documents.get"],
    exact: true,
    nav: {
      group: "information",
      groupTitle: "headerMenu.information",
      title: "headerMenu.information_sub_Documents",
      order: 1,
    },
  },
  {
    name: "DOCUMENTS_CHILD",
    pageComponent: Catalogs,
    path: "/documents/sub_catalogs/:id",
    icon: SystemRoles,
    permissions: ["documents.get"],
    exact: true,
  },
  {
    name: "DOCUMENTS_IS_CATALOG",
    pageComponent: Documents,
    path: "/documents/documents_in_catalog/:id",
    icon: SystemRoles,
    permissions: ["documents.get"],
    exact: true,
  },
  {
    name: "DOCUMENTS_VIEW",
    pageComponent: DocumentView,
    path: "/documents/viewing/:id",
    permissions: ["documents.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "REPORTS",
    pageComponent: IndicatorReports,
    path: "/reports",
    icon: SystemRoles,
    permissions: ["indicatorGroupReports.indicatorGroup.get"],
    exact: true,
    nav: {
      group: "accounting",
      title: "headerMenu.accounting_sub_Reports",
      order: 5,
    },
  },
  {
    name: "REPORTS",
    pageComponent: IndicatorReports,
    path: "/reports/:id",
    icon: SystemRoles,
    permissions: ["indicatorGroupReports.indicatorReport.get"],
    exact: true,
  },
  {
    name: "REPORTS",
    pageComponent: ViewReport,
    path: "/reports/view/:id",
    icon: SystemRoles,
    permissions: ["indicatorGroupReports.report.getDealerIndicatorValues"],
    exact: true,
  },
  {
    name: "ANNOUNCEMENT_BASE",
    pageComponent: AnnouncementEdit,
    path: "/announcement/:id",
    icon: SystemRoles,
    permissions: ["announcements.get"],
    exact: true,
  },
  {
    name: "ANNOUNCEMENT_VIEWING",
    pageComponent: AnnouncementViewing,
    path: "/announcement/viewing/:id",
    permissions: ["announcements.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "USERS",
    pageComponent: UsersPage,
    path: "/users/",
    permissions: ["user.getUsers"],
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "settings",
      title: "headerMenu.settings_sub_Users",
      order: 2,
    },
  },
  {
    name: "BASE_TARIFFS",
    pageComponent: BaseTariffs,
    path: "/editor/base-tariffs",
    access: ["admin"],
    permissions: ["employeeAccounting.tariffs.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "PARTNERS",
    pageComponent: Partners,
    path: "/staff/licenses/partners",
    access: ["admin"],
    permissions: ["employeeAccounting.partners.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "TRAINING_MANAGEMENT",
    pageComponent: TrainingManagement,
    path: "/staff/licenses",
    access: ["admin"],
    permissions: ["employeeAccounting.licenses.get"],
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_Licenses",
      order: 8,
    },
  },
  {
    name: "LICENSE_ORGANIZATION",
    pageComponent: LicenseOrganization,
    path: "/staff/licenses/organization",
    access: ["admin"],
    permissions: ["employeeAccounting.licenses.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "LICENSE_POSITION_GROUP",
    pageComponent: LicensePositionGroup,
    path: "/staff/licenses/position-group",
    access: ["admin"],
    permissions: ["employeeAccounting.licenses.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "LICENSE_MANAGEMENT",
    pageComponent: LicenseManagement,
    path: "/staff/licenses/requests",
    access: ["admin", "dealer", "holding"],
    permissions: ["employeeAccounting.license-requests.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "REGMEN",
    pageComponent: RegMen,
    path: "/reg_men/",
    icon: SystemRoles,
    permissions: ["users.getRegMens"],
    exact: true,
    nav: {
      group: "dealers",
      title: "headerMenu.dealers_sub_RegMen",
      order: 2,
    },
  },
  {
    name: "INDICATORS",
    pageComponent: IndicatorsPage,
    path: "/indicators/",
    icon: SystemRoles,
    permissions: ["indicator.get"],
    exact: true,
    nav: {
      group: "settings",
      title: "headerMenu.settings_sub_Indicators",
      order: 6,
    },
  },
  {
    name: "UPLOADS",
    pageComponent: UploadsPage,
    path: "/uploads/",
    icon: SystemRoles,
    permissions: ["indicator.uploadLog.get"],
    exact: true,
    nav: {
      group: "settings",
      title: "headerMenu.settings_sub_Uploads",
      order: 5,
    },
  },
  {
    name: "EDITOR",
    pageComponent: EditorPage,
    path: "/editor/",
    permissions: EDITOR_PAGE_PERMISSIONS,
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "settings",
      groupTitle: "headerMenu.settings",
      title: "headerMenu.settings_sub_Editor",
      order: 1,
    },
  },
  {
    name: "EDITOR_ZD",
    pageComponent: EditorServiceAuthorization,
    path: "/editor/zd",
    icon: SystemRoles,
    permissions: ["zd.byId.get"],
    exact: true,
  },
  {
    name: "EDITOR_DEALERS_METRICS",
    pageComponent: EditorDealerMetric,
    path: "/editor/dealer-metrics",
    icon: SystemRoles,
    exact: true,
    permissions: ["dealerindicator.metrics.get"],
  },
  {
    name: "REQUISITES",
    pageComponent: RequisitesPage,
    path: "/editor/requisites",
    icon: SystemRoles,
    exact: true,
    permissions: [
      "contracts.createTpm",
      "contracts.changeVasReq",
      "contracts.updateVasReq",
      "contracts.deleteVasReq",
    ],
  },
  {
    name: "EDITOR_REPORTS",
    pageComponent: EditorReports,
    path: "/editor/reports",
    permissions: ["indicatorGroupReports.indicatorReport.create"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EDITOR_IS",
    pageComponent: EditorInformationSystems,
    path: "/editor/is",
    icon: SystemRoles,
    permissions: [
      "employeeAccounting.information.system.get",
      "employeeAccounting.personal.info.get",
    ],
    exact: true,
  },
  {
    name: "EDITOR_IS_PD",
    pageComponent: EditorPersonalData,
    path: "/editor/is/pd",
    icon: SystemRoles,
    permissions: ["employeeAccounting.personal.info.get"],
    exact: true,
  },
  {
    name: "EDITOR_IS_IS",
    pageComponent: EditorInformationSystem,
    path: "/editor/is/dis",
    icon: SystemRoles,
    permissions: ["employeeAccounting.information.system.get"],
    exact: true,
  },
  {
    name: "PLAN_REPORT",
    pageComponent: PlanReport,
    path: "/zd/plan_report",
    icon: SystemRoles,
    permissions: ["zd.planReports.get"],
    exact: true,
  },
  {
    name: "BASE_STAFF",
    pageComponent: BaseStaff,
    path: "/base/staff/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.employee.list.get"],
    exact: true,
    nav: {
      group: "staff",
      title: "headerMenu.staff_sub_BaseStaff",
      order: 1,
    },
  },
  {
    name: "BASE_VIEWING",
    pageComponent: EmployeeProfileViewing,
    path: "/base/viewing/:id",
    icon: SystemRoles,
    permissions: ["employeeAccounting.employee.get"],
    exact: true,
  },
  {
    name: "EDITOR_BASE_STAFF",
    pageComponent: EmployeeProfileEditor,
    path: "/base/staff/:id",
    icon: SystemRoles,
    permissions: [
      "employeeAccounting.employee.card.edit.all",
      "employeeAccounting.employee.card.edit.partial",
      "employeeAccounting.employee.create",
    ],
    exact: true,
  },
  {
    name: "GLOBAL_RATINGS",
    pageComponent: EditorVersions,
    path: "/editor/gr/",
    permissions: ["globalRatings.versions.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "DIRECTORIES",
    pageComponent: EditorDirectories,
    path: "/editor/directories/",
    icon: SystemRoles,
    permissions: [
      "employeeAccounting.position.get",
      "directions.directions.get",
      "employeeAccounting.combinationRule.get",
    ],
    exact: true,
  },
  {
    name: "POSITIONS_DIRECTORY",
    pageComponent: EditorPositionsDirectory,
    path: "/editor/directories/pd",
    permissions: ["employeeAccounting.position.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "COMBINATION_RULES_DIRECTORY",
    pageComponent: EditorCombinationRules,
    path: "/editor/directories/combination-rules",
    permissions: ["combinationRules.rules.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "DIRECTIONS",
    pageComponent: EditorDirections,
    path: "/editor/directories/ed",
    icon: SystemRoles,
    permissions: ["directions.directions.get"],
    exact: true,
  },
  {
    name: "CATALOG_EDUCATIONAL_PROGRAMS",
    pageComponent: EditorCatalogEducationalPrograms,
    path: "/editor/cep/",
    icon: SystemRoles,
    permissions: [
      // "indicatorGroupReports.indicatorGroup.create",
      "indicatorGroupReports.indicatorReport.create",
      "employeeAccounting.education.catalog.create",
      "employeeAccounting.curriculum.group.get",
      "employeeAccounting.curriculum.level.get",
      "employeeAccounting.curriculum.course.get",
      "employeeAccounting.curriculum.program.get",
    ],
    exact: true,
  },
  {
    name: "EDITOR_REFERENCE_BOOKS_DOCUMENT_LIBRARY",
    pageComponent: EditorDocumentSection,
    path: "/editor/doc/",
    icon: SystemRoles,
    permissions: ["documents.getSection"],
    exact: true,
  },
  {
    name: "EDITOR_REFERENCE_BOOKS_DOCUMENT_LIBRARY_CHILD",
    pageComponent: EditorDocumentSection,
    path: "/editor/doc/:id",
    permissions: ["documents.getSection"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EDITOR_PHOTO_GALLERY",
    pageComponent: EditorPhotoGallery,
    path: "/editor/photo-gallery/",
    permissions: ["photoGallery.section.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "ADDRESS_SELECTION_GUIDE",
    pageComponent: AddressSelectionGuide,
    path: "/editor/address_selection_guide/",
    icon: SystemRoles,
    exact: true,
    permissions: ["addressSelectionguide.get"],
  },
  {
    name: "CONTRACT_TEMPLATES",
    pageComponent: ContractTemplates,
    path: "/editor/contract-templates/",
    icon: SystemRoles,
    exact: true,
    permissions: ["contracts.createTpm"],
  },
  {
    name: "IVIDEON_PLANS",
    pageComponent: IvideonPlans,
    path: "/editor/ivideon-plans/",
    icon: SystemRoles,
    exact: true,
    permissions: ["ivideon.getCameraTariffs"],
  },
  {
    name: "DNM_ROLE_MAPPINGS",
    pageComponent: DnmRoleMappings,
    path: "/editor/dnm-role-mappings/",
    icon: SystemRoles,
    exact: true,
    permissions: ["dealer.getDnmRoleMappings"],
  },
  {
    name: "CONTEST_TERRITORIES",
    pageComponent: ContestTerritories,
    path: "/editor/contest-territories/",
    icon: SystemRoles,
    exact: true,
    permissions: ["competitiveTerritories.view"],
  },
  {
    name: "EP_GROUPS",
    pageComponent: EditorGroups,
    path: "/editor/cep/groups/",
    permissions: ["employeeAccounting.curriculum.group.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EP_LEVELS",
    pageComponent: EditorLevels,
    path: "/editor/cep/levels/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.curriculum.level.get"],
    exact: true,
  },
  {
    name: "EP_COURSES",
    pageComponent: EditorCourses,
    path: "/editor/cep/courses/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.curriculum.course.get"],
    exact: true,
  },
  {
    name: "EP_POSITIONS_AND_TRAININGS_PROGRAM",
    pageComponent: EditorPositionsAndTrainingPrograms,
    path: "/editor/cep/ptp/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.curriculum.program.get"],
    exact: true,
  },
  {
    name: "EP_POSITIONS_VIEW_AND_TRAININGS_PROGRAM",
    pageComponent: EditorPositionsAndTrainingPrograms,
    path: "/editor/cep/view/ptp/",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EP_POSITIONS_AND_TRAININGS_PROGRAM",
    pageComponent: EducationalProgramsManagement,
    path: "/editor/cep/ptp/:id",
    permissions: ["employeeAccounting.curriculum.program.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EP_POSITIONS_VIEW_AND_TRAININGS_PROGRAM",
    pageComponent: EducationalProgramsManagement,
    path: "/editor/cep/view/ptp/:id",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EP_POSITIONS_AND_TRAININGS_PROGRAM_EDIT",
    pageComponent: ProgramsManagement,
    path: "/editor/cep/ptp/edit/:id",
    permissions: ["employeeAccounting.curriculum.program.update"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "EP_ADD_POSITIONS_AND_TRAININGS_PROGRAM",
    pageComponent: ProgramsManagement,
    path: "/editor/cep/ptp/create",
    icon: SystemRoles,
    permissions: ["employeeAccounting.curriculum.program.create"],
    exact: true,
  },
  {
    name: "STAFF_EDITOR",
    pageComponent: EditorStaffIndicators,
    path: "/editor/staff/",
    icon: SystemRoles,
    permissions: ["employeeAccounting.expectations"],
    exact: true,
  },
  {
    name: "SUBDIVISION_EDITOR",
    pageComponent: EditorSubdivision,
    path: "/editor/subdivision/",
    icon: SystemRoles,
    permissions: ["subdivisions.getList"],
    exact: true,
  },
  {
    name: "PKD",
    pageComponent: PKD,
    path: "/pkd/",
    icon: SystemRoles,
    permissions: ["pkd.getFiles"],
    exact: true,
    nav: {
      group: "analytics",
      title: "headerMenu.analytics_sub_PKD",
      order: 3,
    },
  },
  {
    name: "PKDFiles",
    pageComponent: PKDFiles,
    path: "/pkd/:name/:name",
    icon: SystemRoles,
    permissions: ["pkd.getFiles"],
    exact: true,
  },
  {
    name: "VIOLATIONS",
    pageComponent: Violations,
    path: "/violations/",
    icon: SystemRoles,
    permissions: ["violations.getAll"],
    exact: true,
    nav: {
      group: "accounting",
      title: "headerMenu.accounting_sub_Violations",
      order: 4,
    },
  },
  {
    name: "VIOLATION_RECORDING",
    pageComponent: ViolationRecording,
    path: "/violations/violation_recording/:id",
    icon: SystemRoles,
    permissions: ["violations.create"],
    exact: false,
  },
  {
    name: "VIOLATIONS_DESCRIPTION",
    pageComponent: ViolationDescription,
    path: "/violations/description/:id",
    icon: SystemRoles,
    permissions: ["violations.getById"],
    exact: true,
  },
  {
    name: "CATALOG_APPLICATIONS",
    pageComponent: CatalogApplications,
    path: "/catalogApplications/",
    icon: SystemRoles,
    permissions: ["candidateSelection.candidates.get"],
    exact: true,
    nav: {
      group: "dealers",
      title: "headerMenu.dealers_sub_Candidates",
      order: 4,
    },
  },
  {
    name: "CATALOG_INFO",
    pageComponent: CatalogInfo,
    path: "/catalogApplications/:id",
    icon: SystemRoles,
    permissions: ["candidateSelection.candidates.get"],
    exact: true,
  },
  {
    name: "EDITOR_TRUSTED_PERSONS",
    pageComponent: EditorTrustedPersons,
    path: "/editor/trusted_persons/",
    icon: SystemRoles,
    exact: true,
    permissions: [
      "editor.contracts.trusted.create",
      "editor.contracts.trusted.edit",
    ],
  },
  {
    name: "QUARTILES",
    pageComponent: EditorVersions,
    path: "/editor/q/",
    permissions: ["quartilesRatings.versions.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "VIOLATION_TYPES",
    pageComponent: ViolationType,
    path: "/editor/violation/",
    permissions: ["violationsTypes.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "MANAGING_GR_INDICATORS",
    pageComponent: EditorGRIndicators,
    path: "/editor/gr/:id",
    permissions: ["globalRatings.ratings.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "MANAGING_Q_INDICATORS",
    pageComponent: EditorQIndicators,
    path: "/editor/q/:id",
    icon: SystemRoles,
    permissions: [
      "quartilesRatings.versions.get",
      "quartilesRatings.ratings.get",
    ],
    exact: true,
  },
  {
    name: "REGISTRY_OF_ROLE",
    pageComponent: RegistryOfRole,
    path: "/registry_of_role/",
    permissions: ["users.access.roles"],
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "settings",
      title: "headerMenu.settings_sub_Roles",
      order: 3,
    },
  },
  {
    name: "ROLE_MODEL",
    pageComponent: RoleModel,
    path: "/registry_of_role/:id",
    icon: SystemRoles,
    permissions: ["users.access.roles"],
    exact: false,
  },
  {
    name: "LOGS",
    pageComponent: LogsPage,
    path: "/logs/",
    permissions: ["log.get"],
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "settings",
      title: "headerMenu.settings_sub_Logs",
      order: 4,
    },
  },
  {
    name: "INTEGRATIONS_LOGS",
    pageComponent: IntegrationsLogs,
    path: "/logs/integrations",
    permissions: ["log.getcronlogs"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "IVIDEON_LOGS",
    pageComponent: IvideonLogs,
    path: "/logs/ivideon",
    icon: SystemRoles,
    permissions: ["log.users.activity"],
    exact: true,
  },
  {
    name: "LOGS_EMAIL",
    pageComponent: EmailLogs,
    path: "/logs/email",
    permissions: ["log.email.get"],
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "SSR",
    pageComponent: SRR,
    path: "/srr/",
    permissions: [
      "srr.target.get",
      "srr.gibdd.get",
      "srr.carArrivals.get",
      "srr.family.get",
      "srr.other.get",
      "srr.ssr35.get",
      // "srr.uvin.get",
      // "srr.ns.get",
      "srr.oneCSales.get",
    ],
    icon: SystemRoles,
    exact: true,
    nav: {
      group: "accounting",
      title: "headerMenu.accounting_sub_SRR",
      order: 3,
    },
  },
  {
    name: "GIBDD",
    pageComponent: GIBDD,
    path: "/srr/gibdd",
    permissions: ["srr.gibdd.set"],
    icon: SystemRoles,
    exact: true,
  },

  // 404
  {
    name: "Page not found",
    pageComponent: PageNotFound,
    path: "/404",
    icon: SystemRoles,
    exact: true,
  },
  {
    name: "PKD_UPLOADS",
    pageComponent: PKD,
    path: "/pkd",
    icon: SystemRoles,
    permissions: ["pkd.getFiles"],
    exact: true,
  },
  {
    name: "PKD_INDICATORS",
    pageComponent: CobWeb,
    path: "/pkd/indicators/",
    icon: SystemRoles,
    permissions: ["pkd.getThree"],
    exact: true,
  },
  {
    name: "PKD_INDICATORS_DEPARTMENT",
    pageComponent: CobWebDepartment,
    path: "/indicators-department/:id",
    icon: SystemRoles,
    permissions: ["pkd.getThree"],
    exact: true,
  },
  {
    name: "PKD_CHECKLISTS",
    pageComponent: Checklists,
    path: "/pkd/checklists/",
    icon: SystemRoles,
    permissions: ["pkd.getCheckLists"],
    exact: true,
  },
  {
    name: "CHECKLIST",
    pageComponent: Checklist,
    path: "/checklists/:id",
    icon: SystemRoles,
    permissions: ["pkd.getCheckLists"],
    exact: true,
  },
  {
    name: "DEPARTMENT_CHECKLIST",
    pageComponent: DepartmentCheckList,
    path: "/checklists-department/:id",
    icon: SystemRoles,
    permissions: ["pkd.getCheckLists"],
    exact: true,
  },
  {
    name: "STAFF_EMPLOYEE_PERSONAL",
    pageComponent: StaffEmployeePersonal,
    path: "/staff/employee/personal",
    icon: SystemRoles,
    exact: true,
  },

  // Redirect
  {
    isRedirect: true,
    name: "Redirect",
    pageComponent: PageNotFound,
    path: "/404",
    icon: SystemRoles,
    exact: true,
  },
];
